import React from 'react';
import { Box, makeStyles, Typography } from '@material-ui/core';
import clsx from 'clsx';

const useStyles = makeStyles(theme => ( {
	root: {
		borderBottom: `1px solid ${theme.palette.divider}`
	}
}))

function DetailItem({ title, value, className, ...rest }) {
	const classes = useStyles();

	return (
		<Box className={clsx(classes.root, className)} px={2} pb={'2px'} mb={1} {...rest} >
			<Typography
				variant="subtitle2"
				color="primary"
			>
				{title}
			</Typography>
			<Typography variant="body2" color="textPrimary">
				{value || <>&nbsp;</>}
			</Typography>
		</Box>
	);
}

export default DetailItem;
